import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LogQueryCreateForm } from "./components/LogQueryCreateForm";

export function NewLogQueryPage() {
  return (
    <Page title="New Query">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogQueryCreateForm />
      </Container>
    </Page>
  );
}
